var React = require('react');

function Blanket (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 464v32a16 16 0 0 1-16 16H128C57.17 512-.41 454.17 0 383.25.41 312.62 58.78 256 129.41 256H432a80.09 80.09 0 0 1 80 80.79c-.43 44-37 79.21-81 79.21H128a32 32 0 0 1-32-32.9c.48-17.43 15.22-31.1 32.66-31.1H432a16 16 0 0 0 16-16.81c-.42-8.59-7.84-15.19-16.44-15.19H128a64.06 64.06 0 0 0-64 65c.53 35.12 29.84 63 65 63h367a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512 96s-.07 179.79-.28 233.47A80.1 80.1 0 0 0 432 256H129.41C58.78 256 .41 312.62 0 383.25v.73V96A96.14 96.14 0 0 1 96 0h320a96.14 96.14 0 0 1 96 96z","className":"fa-primary","key":2})]);
}

Blanket.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Blanket;

Blanket.default = Blanket;
